$(document).ready(function(){
    $('.font-option').click(function(){
        $('.font-option').removeClass('selected');
        $(this).addClass('selected');
        
        var $fabric = $(this).attr(value);
        var $fabricChoice = $(this).parent().parent().parent().find('.fabric-choice');
        $fabricChoice.text($fabric);
    })

    $('.fabric-option__secondary').click(function(){
        $('.fabric-option__secondary').removeClass('selected');
        $(this).addClass('selected');

        var $fabric = $(this).val()
        var $fabricChoice = $(this).parent().parent().parent().find('.fabric-choice');
        $fabricChoice.text($fabric);
    });

    // Show & hide name field
    var $fieldHeight = $('.product-customiser__field-name').height();
    console.log($fieldHeight);
    $('.product-customiser__field-name').css('max-height', '0px');
        $('#include-personalised-name').change(function(){
            if(this.value == 'Yes') {
            $('.product-customiser__field-name').css('max-height', $fieldHeight);
        } else {
            $('.product-customiser__field-name').css('max-height', '0px');
        }
    })

    // Accordions
    $('.accordion--toggle').click(function(){
        $(this).parent().find('.accordion--content').toggleClass('is--closed');
    });

    $('.fabric-selector').click(function(){
        fabricValue = $(this).val();
        $(this).parent().parent().addClass('is--closed')
        $(this).parent().parent().parent().find('.accordion--toggle > span').html(fabricValue);
    });

    $('.fabric-option__secondary').click(function(){
        $(this).parent().parent().addClass('is--closed')
    });

    $('.accordion--content').each(function(){
        var $height = $(this).height();
        $(this).css('height', $height);
    });

    // Option Modals
    $('.product-customiser__option-toggle').on('click', function(e){
        e.preventDefault();
        $('body').css('overflow', 'hidden');
        var opensModal = $(this).attr('data-opens');
        $(`[data-modal='${opensModal}']`).removeClass('hide');
    });

    $(document).on('click', '.option-modal__close', function(e){
        e.preventDefault();
        $('body').css('overflow', 'scroll');
        $(this).parent().closest('.option-modal').addClass('hide');
    });

    $(document).on('click', '.option-modal__option', function(e){
        $('body').css('overflow', 'scroll');
        $(this).parent().closest('.option-modal').addClass('hide');

        // set toggle image to selection
        var image = $(this).find('img').attr('src');
        var controls = $(this).attr('data-controls');
        $(`[data-imagefrom='${controls}']`).attr('src', image);
     	console.log(image);
    });

    // preview text
    $('#preview-text').on('keypress', function (event) {
        var textarea = $(this),
            text = textarea.val(),
            numberOfLines = (text.match(/\n/g) || []).length + 1,
            maxRows = parseInt(textarea.attr('rows'));

        if (event.which === 13 && numberOfLines === maxRows ) {
            return false;
        }
    });

})